import '../../sass/blocks/locations.scss';

(() => {
    const $locations = document.querySelectorAll('.locations');

    if (!$locations) return;

    const iconPath = 'M1.5,6a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0';

    const inactiveIcon = {
        path: iconPath,
        fillColor: '#FFFFFF',
        fillOpacity: 1,
        strokeColor: '#1F493D',
        strokeWeight: 3,
        rotation: 0,
        anchor: new google.maps.Point(6, 6),
    };

    const activeIcon = {
        path: iconPath,
        fillColor: '#1F493D',
        fillOpacity: 1,
        strokeColor: '#1F493D',
        strokeWeight: 3,
        rotation: 0,
        anchor: new google.maps.Point(6, 6),
    };

    const mapStyle = [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "color": "#e5ede4"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#0096aa"
                },
                {
                    "visibility": "off"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#7ea699"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];

    $locations.forEach($locations => {
        const $categoryLinks = $locations.querySelectorAll('.locations-category-link');
        const $carousel = $locations.querySelector('.locations__carousel');
        const $cardMaps = $locations.querySelectorAll('.location-card__map');
        const $globalPartners = $locations.querySelector('.locations__global-partners');

        let carousel = null;

        const setActiveNav = () => {
            if (!$categoryLinks || !carousel) return;

            $categoryLinks.forEach($categoryLink => {
                const slideIndex = $categoryLink?.dataset?.slideIndex ? parseInt($categoryLink.dataset.slideIndex) : 0;

                if (slideIndex === carousel?.activeIndex) {
                    $categoryLink.classList.add('locations-category-link--active');
                }

                if (slideIndex !== carousel?.activeIndex) {
                    $categoryLink.classList.remove('locations-category-link--active');
                }
            });
        };

        const initcarousel = () => {
            if (!$carousel) return;

            carousel = new Swiper($carousel, {
                allowTouchMove: false,
            });

            if (carousel) {
                carousel.on('slideChange', () => {
                    setActiveNav();
                });
            }

            if ($categoryLinks) {
                $categoryLinks.forEach($categoryLink => {
                    $categoryLink.addEventListener('click', () => {
                        const slideIndex = $categoryLink?.dataset?.slideIndex ? parseInt($categoryLink.dataset.slideIndex) : 0;

                        carousel.slideTo(slideIndex);
                    });
                });
            }
        };

        const initMaps = () => {
            if (!$cardMaps) return;

            $cardMaps.forEach($cardMap => {
                const { lat, lng } = $cardMap.dataset;

                const mapLatLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

                new google.maps.Map($cardMap, {
                    zoom: 15,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    center: mapLatLng,
                    disableDefaultUI: true,
                    draggable: false,
                    zoomControl: false, 
                    scrollwheel: false, 
                    disableDoubleClickZoom: true,
                });
            });
        };

        const setMapBounds = (map, locations) => {
            const bounds = new google.maps.LatLngBounds();

            if (locations) {
                locations.forEach(location => {
                    const position = new google.maps.LatLng(location?.lat, location?.lng);

                    bounds.extend(position);
                });
            }

            // Don't zoom in too far on only one marker
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
               const extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
               const extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
               
               bounds.extend(extendPoint1);
               bounds.extend(extendPoint2);
            }

            map.fitBounds(bounds);
        };

        const initGlobalPartnersMap = () => {
            if (!$globalPartners) return;

            let { locations } = $globalPartners.dataset;

            if (!locations) return;

            locations = JSON.parse(locations);

            const map = new google.maps.Map($globalPartners, {
                zoom: 15,
                styles: mapStyle,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            });

            const infoWindow = new google.maps.InfoWindow({
                content: '',
                maxWidth: 270,
                disableAutoPan: false,
            });

            const mapMarkers = locations.map(location => {
                const position = new google.maps.LatLng(location?.lat, location?.lng);

                const marker = new google.maps.Marker({
                    position,
                    map,
                    icon: inactiveIcon
                });

                if (location?.name) {
                    marker.addListener('click', () => {
                        if (mapMarkers) {
                            mapMarkers.forEach(marker => {
                                marker.setIcon(inactiveIcon);
                            });
                        }

                        infoWindow.setContent(location.name);
                        infoWindow.open({
                            anchor: marker,
                            map
                        });

                        marker.setIcon(activeIcon);
                    });
                }

                return marker;
            });

            google.maps.event.addListener(map, 'click', () => {
                infoWindow.close();

                mapMarkers.forEach(marker => {
                    marker.setIcon(inactiveIcon);
                });
            });

            setMapBounds(map, locations);
        };

        initcarousel();
        initMaps();
        initGlobalPartnersMap();
    });
})();
